<template>
  <div>
    <div class="head">
      <span class="number">提交时间：{{ form.createDate }}</span>
      <span class="status">{{ form.dealStatus.label }}</span>
    </div>
    <div class="orderstatus1">
      <div class="context1">
        <i class="iconfont" style="font-size:1.8rem;color:#fff;">&#xe63a;</i>

        <span>受理完成</span>
        <p>已受理完毕</p>
      </div>
    </div>
    <div class="bespeakinfo">
      <span class="title">投诉建议</span>
      <ul>
        <li>
          <span class="color">投诉建议</span> <span class="value">{{ form.category.label }}</span>
        </li>
        <li>
          <span class="color">详细描述</span> <span class="value">{{ form.content }}</span>
        </li>
        <li></li>
      </ul>
      <div class="time">
        <span class="color">处理时间</span> <span class="date">{{ form.dealDate }}</span>
      </div>
    </div>
    <div class="bespeakinfo" v-if="form.dealStatus == 1">
      <span class="title">受理结果</span>
      <ul>
        <li>
          <span class="color">受理结果</span> <span class="value">{{ form.dealResult }}</span>
        </li>
        <li></li>
      </ul>
    </div>
    <div></div>
  </div>
</template>

<script>
export default {
  name: 'tousuyijiandetail',
  data() {
    return {
      form: {
        id: 0,
        category: {},
        content: '',
        gallery: [],
        dealStatus: {},
        dealDate: '',
        dealResult: '',
        createDate: '',
      },
    }
  },
  created() {
    this.querySuggestionOne()
  },
  mounted() {},
  methods: {
    querySuggestionOne() {
      var that = this
      this.$queryOne(
        'MsgSuggestion',
        {},
        [
          'id',
          'category',
          'content',
          'gallery',
          'dealStatus',
          'dealDate',
          'dealResult',
          'createDate',
        ],
        function(res) {
          that.$fill(that.form, res.data)
        }
      )
    },
  },
}
</script>

<style>
.head {
  width: 100%;
  height: 4.6rem;
  background-color: #fff;
  font-size: 1.4rem;
  padding-left: 2rem;
  padding-top: 1.3rem;
}
.head span {
  font-size: 1.4rem;
}
.head .status {
  float: right;
  position: relative;
  right: 1.5rem;
  color: #15a892;
}
.head span {
  font-size: 1.4rem;
}
.orderstatus1 {
  width: 100%;
  margin-top: 0.8rem;
  padding: 0 1rem;
  letter-spacing: 0.1rem;
}
.orderstatus1 .context1 {
  width: 100%;
  text-align: center;
  padding: 1.9rem 2rem;
  font-size: 1.6rem;
  line-height: 2.5rem;
  background-color: #15a892;
}
.orderstatus1 .context1 .cha,
.orderstatus1 .context1 .svg11 {
  width: 1.5rem;
  height: 1.5rem;
  position: relative;
  top: 0.2rem;
}
.orderstatus1 .context1 p,
.orderstatus1 .context1 span {
  color: #fff;
}
.orderstatus1 .context1 p,
.orderstatus1 .context1 span {
  color: #fff;
}
.orderstatus1 p {
  font-size: 1.4rem;
  margin-top: 0.5rem;
}
.bespeakinfo {
  width: calc(100% - 2rem);
  background-color: #fff;
  margin: 1rem;
  padding: 1.5rem 0;
}
.bespeakinfo .title {
  font-size: 1.6rem;
  padding: 0 1.5rem 1rem;
  border-bottom: 1px solid #eee;
  width: 100%;
  display: inline-block;
}
.bespeakinfo ul {
  list-style: none;
  padding: 0 1.5rem;
}
.bespeakinfo > ul:before {
  content: '';
  display: table;
}
.bespeakinfo ul li {
  width: 100%;
  font-size: 1.4rem;
  float: left;
  padding-top: 0.5rem;
  margin-top: 1rem;
}
.bespeakinfo ul li .color {
  color: #999;
}
.bespeakinfo ul li .value {
  margin-left: 1.5rem;
}
.bespeakinfo ul li .color {
  color: #999;
}
.bespeakinfo ul li .value {
  margin-left: 1.5rem;
}
.bespeakinfo ul li {
  width: 100%;
  font-size: 1.4rem;
  float: left;
  padding-top: 0.5rem;
  margin-top: 1rem;
}
.bespeakinfo > ul:after {
  content: '';
  display: table;
  clear: both;
}
.bespeakinfo .time {
  margin-top: 1rem;
  font-size: 1.4rem;
  padding-left: 1.5rem;
}
.time {
  margin-top: 6rem;
  font-size: 1.4rem;
}
.bespeakinfo .time .color {
  color: #999;
}
.time .color {
  color: #999;
}
.bespeakinfo .time .date {
  position: relative;
  left: 1.5rem;
}
.time .date {
  position: relative;
  left: 2rem;
}
</style>
